import { withInstall } from "../utils/index.mjs";
import _DatePicker from "./DatePicker.mjs";
const DatePicker = withInstall(_DatePicker);
var stdin_default = DatePicker;
import { datePickerProps } from "./DatePicker.mjs";
export {
  DatePicker,
  datePickerProps,
  stdin_default as default
};
